export default {
    load: {
      key: process.env.VUE_APP_GOOGLE_KEY
    },
}